import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Table } from 'antd';
import dayjs from 'dayjs';
import { toISTDate } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import PurchaseRequestActions from '@Actions/purchaseRequestActions';
import UserActions from '@Actions/userActions';
import H3Modal from '@Uilib/H3Modal';
import ViewSalesOrder from '@Components/Sales/SalesOrder/ViewSalesOrder';
import './style.scss';
import documentUINamesConstant from '../../../../apis/documentUINamesConstant';
import HideValue from '../../../Common/RestrictedAccess/HideValue';

class SalesOrdersList extends Component {

  constructor(props) {
    super(props);
    const { priceMasking } = props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
    this.state = {
      currentPage: 1,
      limit: 10,
      startDate: dayjs().valueOf(),
      openSelectedDuration: dayjs().subtract(300, 'd').valueOf(),
      closedSelectedDuration: 'LAST 60 DAYS',
      openPurchaseOrderModal: false,
      openGRNModal: false,
      openGRNModalView: false,
      openUpdatePurchaseOrderModal: false,
      expandedRowKeys: [],
      tableColumns: (documentUINames) => [
        {
          title: '',
          render: (record) => (
            <div onClick={() => this.setState({ selectedSalesOrder: record, showSoModal: true })}>
              <div className="mobile-list__item">
                <div style={{ display: 'flex' }}>
                  <H3Text text={`#${record?.sales_order_number}`} className="mobile-list__item-number" />
                </div>
                <div className="mobile-list__item-info">
                  {`Business Unit - ${record.tenant_info?.tenant_name}`}
                </div>
                <div className="mobile-list__item-info">
                  {`Customer - ${record?.customer_info?.customer_name}`}
                </div>
                <div className="mobile-list__item-info">
                  {`Items - ${record.no_of_items}`}
                </div>
                <H3Text text={`Delivery Date - ${toISTDate(record?.delivery_date).format('DD/MM/YYYY')}`} className="mobile-list__item-info" />
                <H3Text text={`Total Amount - ${this.props.MONEY(record?.order_grand_total)}`} className="mobile-list__item-info" />
                <H3Text text={`Requested by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer" />
              </div>
            </div>
          ),
          responsive: ['xs'],
        },
        {
          title: window.location.href.includes('/pending-estimate') ? `${documentUINames.estimateShortUIName} #` : `${documentUINames.salesOrderShortUIName} #`,
          render: (record) => (
            <div className="column-number__wrapper">
              {record?.sales_order_number}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'BUSINESS UNIT',
          render: (text, record) => (
            <div className="associated-entity">
              {record.tenant_info?.tenant_name}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'CUSTOMER',
          render: (text, record) => {
            const { user } = this.props;
            return (
              <div className="associated-entity">
                {record?.customer_info?.customer_name}
              </div>
            );
          },
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'ITEMS',
          render: (item) => (
            <div>
              {item?.no_of_items}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: window.location.href.includes('/pending-estimate') ? `${documentUINames.estimateShortUIName.toUpperCase()} DATE` : `${documentUINames.salesOrderShortUIName.toUpperCase()} DATE`,
          render: (record) => (
            <div>
              <div className="column-date">
                {toISTDate(record?.order_date).format('DD/MM/YYYY')}
              </div>
              <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'DELIVERY DATE',
          render: (record) => (
            <div className="colummn-date">
              {toISTDate(record?.delivery_date).format('DD/MM/YYYY')}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: window.location.href.includes('/pending-estimate') ? `${documentUINames.estimateShortUIName.toUpperCase()} TOTAL AMOUNT` : `${documentUINames.salesOrderShortUIName.toUpperCase()} TOTAL AMOUNT`,
          render: (item, record) => (
            <div className="column-amount">
              {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={`You don't have access to view ${documentUINames.estimateShortUIName.toLowerCase()} total amount`} /> : this.props.MONEY((record?.document_order_grand_total || record?.order_grand_total || '0'), record?.org_currency_info?.currency_code)}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: '',
          key: 'action',
          fixed: 'right',
          render: (record) => (
            <div className="list__actions">
              <div className="list__actions-button list__actions-button-dark" onClick={() => this.setState({ selectedSalesOrder: record, showSoModal: true })}>
                View
              </div>
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          className: 'list__actions-column',
        },
      ],
      documentUINames: {},
    };
  }

  componentDidMount() {

  }

  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.isUserReady) {
      const { getPendingActions } = props;
      getPendingActions(`${window.location.href.includes('/pending-estimate') ? 'map_se' : 'map_so'}`, 10, state.currentPage, () => { });
      return {
        ...state,
        documentUINames: documentUINamesConstant(props.user),
        isUserReady: true,
      };
    }
    return state;
  }

  render() {
    const {
      pendingActions, getPendingActionsLoading, getPendingActions,
    } = this.props;
    const {
      currentPage, tableColumns, showSoModal, selectedSalesOrder, documentUINames,
    } = this.state;
    return (
      <Fragment>
        <div className="doc-list__wrapper">
          <div className="ant-row">
            <div className="ant-col-md-24 ant-col-xs-24">
              <div className="doc-list__table-wrapper">
                <Table
                  title={() => (
                    <div className="doc-list__table-header">
                      <div className="doc-list__table-header__left">
                        {`${window.location.href.includes('/pending-estimate') ? Number(pendingActions?.se_approval_count) : Number(pendingActions?.so_approval_count)} ${window.location.href.includes('/pending-estimate') ? (documentUINames.estimateUIName || 'Estimates') : (documentUINames.salesOrderUIName || 'Sales Orders')}`}
                      </div>
                    </div>
                  )}
                  loading={getPendingActionsLoading}
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={tableColumns(documentUINames)}
                  rowKey="po_id"
                  dataSource={(window.location.href.includes('/pending-estimate')) ? (pendingActions?.sales_estimates || []) : (pendingActions?.sales_orders || [])}
                  pagination={(window.location.href.includes('/pending-estimate') ? Number(pendingActions?.se_approval_count) : Number(pendingActions?.so_approval_count) > 10) ? {
                    defaultCurrent: 1,
                    current: currentPage,
                    total: window.location.href.includes('/pending-estimate') ? Number(pendingActions?.se_approval_count) : Number(pendingActions?.so_approval_count),
                    pageSize: 10,
                    onChange: (page) => {
                      getPendingActions(`${window.location.href.includes('/pending-estimate') ? 'map_se' : 'map_so'}`, 10, currentPage, () => { });
                      this.setState({ currentPage: page });
                    },
                    position: ['bottomRight'],
                    showSizeChanger: false,
                  } : false}
                />
              </div>
            </div>
          </div>
        </div>
        <H3Modal
          onClose={() => {
            getPendingActions(`${window.location.href.includes('/pending-estimate') ? 'map_se' : 'map_so'}`, 10, currentPage, () => { });
            this.setState({ showSoModal: false });
          }}
          className="pending-po__view-po"
          isOpen={showSoModal}
          title={`${window.location.href.includes('/pending-estimate') ? (documentUINames.estimateUIName || 'Estimate') : (documentUINames.salesOrderUIName || 'Sales Order')} #${selectedSalesOrder ? selectedSalesOrder?.order_id : ''} for ${selectedSalesOrder?.tenant_info?.tenant_name}`}
          showHeader
          isEstimate={window.location.href.includes('/pending-estimate')}
        >
          <ViewSalesOrder isQuickView isEstimate selectedSoId={selectedSalesOrder?.order_id} selectedTenantId={selectedSalesOrder?.tenant_info?.tenant_id} />
        </H3Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getPendingActionsLoading: UserReducers.getPendingActionsLoading,
  pendingActions: UserReducers.pendingActions,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getPendingActions: (actionType, limit, page, callback) => dispatch(UserActions.getPendingActions(actionType, limit, page, callback)),
  getPurchaseRequestsSuccess: (purchaseRequests) => dispatch(PurchaseRequestActions.getPurchaseRequestsSuccess(purchaseRequests)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SalesOrdersList));
